import {postUpdatePercent} from '../api/postUpdatePercent';
import { setGetReferrals } from './setGetReferrals';

const setPostUpdatePercent = (params) => {
    return async (dispatch, getState) => {
        try {
            await postUpdatePercent(params);       
            dispatch(setGetReferrals({
                page: params?.page + 1,
                rowsPerPage: params?.rowsPerPage,
                search: ''
            }))   
        } catch(error) {
            if (error && error.response && error.response.status === 401) {
                localStorage.removeItem('token');
                window.location.replace(window.location.origin);
            }
        }
    }
}

export {
    setPostUpdatePercent
}